'use client';

import FavoritesDeferred from '@/common/DeferredStreams/FavoritesDeferred';
import TradesDeferred from '@/common/DeferredStreams/TradesDeferred';
import type { FavoritesResult } from '~/server-props/common/getFavorites';
import type { TradesResult } from '~/server-props/common/getTrades';
import type { DeliveryPickupResult } from '~/server-props/vdp/getDeliveryPickup';
import type { DiscountsResult } from '~/server-props/vdp/getDiscounts';
import type { OwnerReviewsResult } from '~/server-props/vdp/getOwnerReviews';
import type { PricingResult } from '~/server-props/vdp/getVehiclePricing';
import type { WhyBuyResult } from '~/server-props/vdp/getWhyBuy';
import DeliveryPickupDeferred from './DeliveryPickupDeferred';
import DiscountsDeferred from './DiscountsDeferred';
import OwnerReviewsDeferred from './OwnerReviewsDeferred';
import PricingDeferred from './PricingDeferred';
import WhyBuyDeferred from './WhyBuyDeferred';

export type VehicleDetailsDeferredProps = {
  deliveryPickupDeferred?: Promise<DeliveryPickupResult | undefined>;
  discountsDeferred?: Promise<DiscountsResult | undefined>;
  favoritesDeferred?: Promise<FavoritesResult | undefined>;
  ownerReviewsDeferred?: Promise<OwnerReviewsResult | undefined>;
  pricingDeferred?: Promise<PricingResult | undefined>;
  tradesDeferred?: Promise<TradesResult | undefined>;
  whyBuyDeferred?: Promise<WhyBuyResult | undefined>;
};

export default function DeferredContextStreams(
  deferredProps: VehicleDetailsDeferredProps
) {
  const {
    deliveryPickupDeferred,
    discountsDeferred,
    favoritesDeferred,
    ownerReviewsDeferred,
    pricingDeferred,
    tradesDeferred,
    whyBuyDeferred
  } = deferredProps;

  return (
    <>
      {deliveryPickupDeferred && (
        <DeliveryPickupDeferred promise={deliveryPickupDeferred} />
      )}
      {discountsDeferred && <DiscountsDeferred promise={discountsDeferred} />}
      {favoritesDeferred && <FavoritesDeferred promise={favoritesDeferred} />}
      {ownerReviewsDeferred && (
        <OwnerReviewsDeferred promise={ownerReviewsDeferred} />
      )}
      {pricingDeferred && <PricingDeferred promise={pricingDeferred} />}
      {tradesDeferred && <TradesDeferred promise={tradesDeferred} />}
      {whyBuyDeferred && <WhyBuyDeferred promise={whyBuyDeferred} />}
    </>
  );
}
